import React from 'react';
import { Card } from 'primereact/card';
import { InputTextarea } from 'primereact/inputtextarea';

const InformacionAdicionalSection = ({ provider, onInputChange }) => {
    return (
        <div className="col-12">
            <Card title="Información Adicional">
                <div className="formgrid grid">
                    <div className="field col-12">
                        <label htmlFor="servicios">Servicios</label>
                        <InputTextarea 
                            id="servicios" 
                            value={provider.SERVICIOS} 
                            onChange={(e) => onInputChange(e, 'SERVICIOS')} 
                            rows={4}
                            placeholder="Descripción de los servicios ofrecidos..."
                        />
                    </div>

                    <div className="field col-12">
                        <label htmlFor="nota">Notas</label>
                        <InputTextarea 
                            id="nota" 
                            value={provider.NOTA} 
                            onChange={(e) => onInputChange(e, 'NOTA')} 
                            rows={4}
                            placeholder="Notas adicionales..."
                        />
                    </div>
                </div>
            </Card>
        </div>
    );
};

export default InformacionAdicionalSection;
